<script setup lang="ts">
import { Head } from "@inertiajs/vue3"

import ErrorLayout from "@/layouts/ErrorLayout.vue"
</script>

<template>
  <Head title="Próximamente" />

  <ErrorLayout
    title="Coming soon"
    subtitle="Esta sección estará disponible pronto"
    description="Estamos preparando este módulo para el panel manager."
  />
</template>
